import Vue from "vue";
import Component from "vue-class-component";
import Feedback from '../Feedback/Feedback'
@Component({
    components: {
        Feedback
    }
})
export default class TheLoginFooter extends Vue {
    pp = false
    fb = false
}